import { ConfigProvider } from 'antd'
import React from 'react'

import { CssIcon } from '@/components/CssIcon'


import { tw } from 'tagged-classnames-free';
import Link from '@/components/Link';
export interface IUserEntryFormContainerProps {
  title?: React.ReactNode
  titleAs?: React.ElementType
  titleClassName?: string
  description?: React.ReactNode
  descClassName?: string
  children?: React.ReactNode
  className?: string
  iconClassName?: string
}

const UserEntryFormContainer: React.FC<IUserEntryFormContainerProps> = (
  props,
) => {
  const {
    title,
    description,
    className,
    children,
    titleAs = 'h1',
    titleClassName,
    descClassName,
    iconClassName,
  } = props
  return (
    <div
      className={tw`
        mx-auto
        flex flex-col justify-center px-4
        py-6 md:px-14 2xl:py-12
        ${className}
      `}
    >
      <Link className='mx-auto mb-3' href={'/'}>
        <CssIcon
          className={tw`
            i-cus--tad-logo-ico
            size-[96px] rounded-[20px]
            ${iconClassName}
          `}
        />
      </Link>
      {React.createElement(
        titleAs,
        {
          className: tw`
            mb-6 mt-0 text-center text-2xl font-semibold text-white md:mb-8
            ${titleClassName}
          `,
        },
        title,
      )}
      {description ? (
        <p
          className={tw`
            text-f-text-tertiary mb-8 text-center text-sm
            ${descClassName}
          `}
        >
          {description}
        </p>
      ) : null}
      <ConfigProvider
        theme={{
          components: {
            Button: {
              fontSize: 18,
            },
          },
        }}
      >
        {children}
      </ConfigProvider>
    </div>
  )
}

export default UserEntryFormContainer
